import React, { type Dispatch, type SetStateAction } from "react";

import { FormProvider, useForm } from "react-hook-form";

import { Button, Input, Modal, useManualModalState } from "@synthesis/shared-ui";

import { useStores } from "../../../store";

interface ModalCreateProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  openModal: () => void;
  closeModal: () => void;
}

const ModalCreate = React.memo((props: ModalCreateProps) => {
  return (
    <Modal.Root manual {...props}>
      <AddModalRenameFolder />
    </Modal.Root>
  );
});

const AddModalRenameFolder = React.memo(() => {
  const { directoryStore } = useStores();
  const { closeModal } = useManualModalState();

  const methods = useForm({
    defaultValues: {
      name: "Безымянная",
    },
  });

  const onSubmit = (data: { name: string }) => {
    directoryStore.addDirectory(data);
    methods.reset({ name: "Безымянная" });
    closeModal();
  };

  return (
    <Modal.Content data-cy="modalCreate-modalContent-projectDocks" className="w-[35vw] min-w-[350px]">
      <Modal.Title>Создать папку</Modal.Title>
      <FormProvider {...methods}>
        <form className="mt-2 px-5 py-2" onSubmit={methods.handleSubmit(onSubmit)}>
          <Input data-cy="modalCreate-input-projectDocks" name="name" placeholder="Название папки" />
          {methods.formState.errors.name && (
            <span className="text-primary-dark mt-2 text-sm">Ошибка: Поле "Название папки" должно быть заполненно</span>
          )}

          <Button data-cy="modalCreate-button-projectDocks" className="mt-2" isFullWidth type="submit">
            Подтвердить
          </Button>
        </form>
      </FormProvider>
    </Modal.Content>
  );
});

export default ModalCreate;
